import debounce from 'lodash.debounce';

// ELEMENTOR Trigger
(function($) {
  $(window).on('elementor/frontend/init', function () {
    elementorFrontend.hooks.addAction('frontend/element_ready/cube-header-slideshow.default', function ($scope) {

      // Inspired by: https://www.sitepoint.com/make-a-simple-javascript-slideshow-without-jquery/
      const slides = $scope.find('.header-slideshow-image');
      const slideInterval = setInterval(nextSlide, 4000);
      let currentSlide = 0;

      initSlideshow();

      function initSlideshow() {
        let slideshowDots = document.createElement('ul');
        slideshowDots.className = 'header-slideshow-dots';

        // Build dots navigation
        slides.each(function (index) {
          let item = document.createElement('li');
          item.setAttribute('data-slide', index);
          if (index === 0) {
            item.className = 'active';
          }
          slideshowDots.appendChild(item);
        });

        $scope.append(slideshowDots);

        $(document).on('click', '.header-slideshow-dots li', function() {
          clearInterval(slideInterval); // Stop autoplay
          showSlide($(this).data('slide'));
        });
      }

      function showSlide(index) {
        $(slides[currentSlide]).removeClass('showing');
        $scope.find(`[data-slide="${currentSlide}"]`).removeClass('active');
        currentSlide = (index + slides.length) % slides.length;
        $(slides[currentSlide]).addClass('showing');
        $scope.find(`[data-slide="${currentSlide}"]`).addClass('active');
      }

      function nextSlide() {
        showSlide(currentSlide + 1);
      }
      function prevSlide() {
        showSlide(currentSlide - 1);
      }



    });
  });
})(jQuery);
